<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="story-1-danti-duck-loses-her-quack">
<h1>Story 1<br/> Danti Duck Loses Her Quack</h1>
<p class="mm" style="text-align: center;margin-top:25px;margin-bottom:25px;"><img alt="" src="media/file2.png" style="width:4.42708in;height:5.52014in"/></p>
<p><strong><em>Danti<br/>
</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?6251b3b7